import { urlFormatter } from "sb-resp-utils";
export var mapLeagueUrl = function (adjustPath, league) {
    var urlParams = urlFormatter.getSportUrl(league.sportName || "") + "/" + urlFormatter.getLeagueUrl(league.name || "");
    league.linkUrl = adjustPath(urlParams);
    return league;
};
//# sourceMappingURL=mapLeagueUrl.js.map